import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { some } from 'lodash';

@Component({
  selector: 'app-specific-vendor-compliance-finding-dropdown',
  templateUrl: './specific-vendor-compliance-finding-dropdown.component.html',
  styleUrls: [
    './specific-vendor-compliance-finding-dropdown.component.less',
    '../client-my-vendor.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SpecificVendorComplianceFindingDropdownComponent implements OnInit {
  @Input() title!: string;
  @Input() componentType: 'companyBackground' | 'insurancePolicies' =
    'companyBackground';
  @Input() result?: string;
  @Input() settings?: boolean | number | string;
  @Input() findings?: boolean | number | string;
  @Input() findingsAndSetting?: {
    title: string;
    finding: any;
    setting: any;
    result: any;
    enabled: boolean;
  }[] = [];

  isCollapsed: boolean = true;
  collapseStates: { [key: string]: boolean } = {};

  toggleCollapse(id: string) {
    this.collapseStates[id] = !this.collapseStates[id];
  }

  formatString(string: string) {
    return string.replace(/[^a-zA-Z ]/g, '').replace(/\s/g, '');
  }

  checkResultsForFailure(
    results:
      | {
          title: string;
          finding: any;
          setting: any;
          result: any;
          enabled: boolean;
        }[]
      | undefined
  ): 'PASSED' | 'FAILED' | 'MISSING' | 'EXPIRED' | 'NOT REQUIRED' {
    const enabledResults = results?.filter((r) => r.enabled);

    if (some(enabledResults, (result) => result.result === 'FAILED')) {
      return 'FAILED';
    }

    if (some(enabledResults, (result) => result.result === 'MISSING')) {
      return 'MISSING';
    }

    if (some(enabledResults, (result) => result.result === 'EXPIRED')) {
      return 'EXPIRED';
    }

    if (
      enabledResults &&
      enabledResults.every((result) => result.result === 'NOT REQUIRED')
    ) {
      return 'NOT REQUIRED';
    }

    return 'PASSED';
  }

  getRequirement(requirement: any) {
    if (typeof requirement === 'boolean') {
      return requirement ? 'Yes' : 'No';
    }

    return requirement;
  }

  // Passing results render as a quiet green V icon — DESIGN.md rule: don't
  // pill the positive state. Chips draw attention; the calm default is no
  // chip. Match against the directive's greenStatuses so we stay in sync.
  isPassedResult(value: string | undefined | null): boolean {
    if (!value) return false;
    const normalized = value.trim().toUpperCase();
    return [
      'PASSED',
      'PASS',
      'PASSING',
      'YES',
      'APPROVED',
      'ACCEPTED',
      'ACTIVE',
      'ACTIVATED',
      'FULL',
      'BASIC',
      'EXEMPT - PASSED',
      'NO LICENSED TRADES',
      'WAIVED FINDINGS'
    ].includes(normalized);
  }

  getFinding(finding: any) {
    const passedValuesMap = new Set(['PASSED']);

    if (passedValuesMap.has(finding)) {
      return 'Yes';
    }

    if (typeof finding === 'boolean') {
      return finding ? 'Yes' : 'No';
    }

    if (!finding) {
      return 'No';
    }

    return finding;
  }

  ngOnInit(): void {
    if (this.findingsAndSetting) {
      this.findingsAndSetting.forEach((fs) => {
        const { title } = fs;

        if (title) {
          Object.assign(this.collapseStates, { [title]: true });
        }
      });
    }
  }
}
